import React, { RefObject, useState } from "react"
import {
  Button,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from "@chakra-ui/react"

type Props = InputProps & {
  inputRef: RefObject<HTMLInputElement>
  isNewPassword: boolean
}

export function PasswordInput({
  value,
  onChange,
  autoFocus,
  inputRef,
  isRequired,
  isNewPassword,
}: Props) {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <InputGroup size="lg">
      <Input
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        isRequired={isRequired}
        ref={inputRef}
        size="lg"
        pr="4.5rem"
        type={showPassword ? "text" : "password"}
        autoComplete={isNewPassword ? "new-password" : "current-password"}
      />
      <InputRightElement width="5.25rem">
        <Button h="1.75rem" size="sm" onClick={() => setShowPassword(s => !s)}>
          {showPassword ? "Hide" : "Show"}
        </Button>
      </InputRightElement>
    </InputGroup>
  )
}
